// First: before any module defines a zod schema.
import './lib/zodJitless';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyNavCollapsed, readNavCollapsed } from './components/navCollapsed';
import './styles.css';

// Before the first render, so a collapsed rail never loads at full width first.
applyNavCollapsed(readNavCollapsed());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service worker for installability/offline shell. Registration fails silently on untrusted certs.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* e.g. self-signed cert not trusted — app still works without it */
    });
  });
}
